<template style="color: var(--primary-color); background-color: var(--primary-color);">
    <div class="footer" id="footer" v-if="isLoggedIn && !hideFooter">
      <router-link :to="hasJoinedPool ? '/match' : '/'" class="footer-option"><img src="../assets/images/home.svg" id="home" :class="{active: activeSection === 'home' || activeSection === 'match'}"><h4 class="menu-text">Home</h4></router-link>
      <router-link to="/pool-settings" class="footer-option"><img src="../assets/images/group.svg" id="pool-settings" :class="{active: activeSection === 'pool-settings'}"><h4 class="menu-text">Gruppe</h4></router-link>
      <router-link to="/log-overview" class="footer-option"><img src="../assets/images/bullet-points.svg" id="log-overview" :class="{active: activeSection === 'log-overview'}"><h4 class="menu-text">Historie</h4></router-link>
      <router-link to="/drinks" class="footer-option"><img src="../assets/images/beer.svg" id="drinks" :class="{active: activeSection === 'drinks'}"><h4 class="menu-text">Drinks</h4></router-link>
      <router-link to="/account" class="footer-option"><img src="../assets/images/account.svg" id="account" :class="{active: activeSection === 'account'}"><h4 class="menu-text">Profil</h4></router-link>
    </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
export default {
  name: 'FooterMenu',
  data() {
    return {
      isLoggedIn: !!this.$store.getters.isLoggedIn,
      hasJoinedPool: false,
      hideFooter: false
    };
  },
  watch:{
    $route (){
      this.checkLoginStatus()
    }
  },
  computed: {
    activeSection() {
      return this.$route.name;
    }
  },
  mounted() {
    this.checkLoginStatus();
    if (this.isLoggedIn) {
      this.getJoinedPools();
    }
  },
  methods: {
    checkLoginStatus(){
      this.isLoggedIn = !!this.$store.getters.isLoggedIn;

      this.hideFooter = !!this.$route.query.c;
    },
    async getJoinedPools() {
      try {
        this.msg = await AuthService.getUserJoinedPools()
        if (this.msg.success) {
          this.hasJoinedPool = this.msg.msg.length > 0
        }
      } catch (e) {
        console.error(e)
        this.hasJoinedPool = false
      }
    }
  }
};
</script>

<style scoped>
h4 {
  color: var(--primary-color);
  text-align: center;
  font-size: 0.7rem;
  font-weight: 500;
  text-decoration: none;
  margin-top: 4px;
}

a {
  text-decoration: none;
}

.footer {
  padding-bottom: 35px;
  padding-top: 10px;
  width: 100vw;
  background: var(--glass-bg); /* Glass effect */
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid var(--border-color);
  color: var(--primary-color);
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  transition: all 0.2s ease;
  position: fixed; /* Stick verify */
  bottom: 0;
  z-index: 1000;
}

.footer img {
  background: none;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  color: var(--primary-color);
  opacity: 0.4; /* Inactive state */
  transition: opacity 0.2s;
}

/* Dark mode: Mache inaktive Icons heller für bessere Sichtbarkeit */
[data-theme='dark'] .footer img {
  opacity: 0.7;
  filter: var(--icon-filter);
}

.footer-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.footer-option.router-link-active img, .footer img.active {
  opacity: 1; /* Active state */
  filter: var(--icon-filter);
}

.footer-option.router-link-active h4 {
  color: var(--primary-color);
  font-weight: 600;
}

.menu-text {
  transition: all 0.2s ease;
  white-space: nowrap;
  margin: 0;
  color: var(--tertiary-color);
  display: none;
}

.footer-option.router-link-active .menu-text {
  color: var(--primary-color);
}


@media only screen and (min-width: 600px) {
  .footer {
    background: var(--glass-bg);
    backdrop-filter: blur(20px);
    border-top: none;
    border-right: 1px solid var(--border-color);
    flex-direction: column;
    position: sticky;
    top: 0;
    left: 0;
    justify-content: flex-start;
    width: 250px; /* specific width */
    height: 100vh;
    padding: 40px 20px;
    align-items: flex-start; /* Align left */
  }

  .footer-option {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 90%;
    margin-bottom: 20px;
    padding: 10px;
    border-radius: var(--radius-m);
    flex: 0; /* Don't stretch */
  }

  .footer-option:hover {
    background: var(--background-secondary);
  }

  .footer img {
    margin-right: 15px;
    width: 24px;
    height: 24px;
  }
  
  .menu-text {
    font-size: 1rem;
    display: block !important; /* Ensure generic styling doesn't hide it */
  }
  
  h4 {
    font-size: 1rem;
    margin: 0;
  }
}
</style>
